import { VariantProps } from 'class-variance-authority';

import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

import styles from './styles.module.css';

const LoadingFormStyled = cnva(`rounded-full bg-gray-600 ${styles['play']}`, {
  variants: {
    size: {
      '3xl': 'size-3.5',
      md: 'size-1.5',
      sm: 'size-1',
    },
    isPause: {
      true: styles['pause'],
    },
  },
  defaultVariants: {
    size: 'md',
    isPause: undefined,
  },
});

export interface LoadingFormProps
  extends VariantProps<typeof LoadingFormStyled> {
  isPause?: boolean;
  className?: string;
}

export const LoadingForm = ({
  isPause,
  size = 'md',
  className,
}: LoadingFormProps) => {
  return (
    <div
      className={cn('inline-flex items-center justify-between', {
        'size-14': size === '3xl',
        'size-6': size === 'md',
        'size-4': size === 'sm',
      })}
      {...createDataAttributes({
        test: 'loading',
      })}
    >
      {Array.from({ length: 3 }).map((o, i) => (
        <span
          key={i}
          className={LoadingFormStyled({ isPause, size, className })}
        />
      ))}
    </div>
  );
};
